import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Link,
  TextField,
  Typography,
} from "@mui/material";
import Navbar from "../../components/navbar/NavBar";
import Footer from "../../components/navbar/Footer";
import { useState } from "react";
import * as toast from "../../utils/alertMessage";
import { ToastContainer } from "react-toastify";

const VastuLandingPage = () => {
  const [email, setEmail] = useState("");
  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();

    if (!email) {
      return toast.error("Please enter your email address");
    }
    toast.success("Thank you for subscribing to us!");
    setEmail("");
  };
  return (
    <Box
      sx={{
        background:
          "linear-gradient(135deg, #fff5f5 0%, #fff 50%, #fff5f5 100%)",
        backgroundSize: "400% 400%",
        animation: "gradientBG 15s ease infinite",
        "@keyframes gradientBG": {
          "0%": { backgroundPosition: "0% 50%" },
          "50%": { backgroundPosition: "100% 50%" },
          "100%": { backgroundPosition: "0% 50%" },
        },
        minHeight: "100vh",
        color: "#333",
      }}
    >
      <Navbar />

      {/* Hero Section */}
      <Box sx={{ pt: 15, pb: 8 }}>
        <Container maxWidth="lg">
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={6}>
              <Typography
                variant="h2"
                component="h1"
                gutterBottom
                sx={{
                  background:
                    "linear-gradient(45deg, #bb0000 30%, #ff4444 90%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontWeight: 700,
                  animation: "fadeInUp 0.8s ease-out",
                  "@keyframes fadeInUp": {
                    from: {
                      opacity: 0,
                      transform: "translateY(20px)",
                    },
                    to: {
                      opacity: 1,
                      transform: "translateY(0)",
                    },
                  },
                }}
              >
                Transform Your Home with Expert Vastu Insights
              </Typography>
              <Typography
                variant="h5"
                paragraph
                sx={{
                  color: "#555",
                  animation: "fadeInUp 0.8s ease-out 0.2s backwards",
                }}
              >
                Unlock your home's hidden potential in minutes.
              </Typography>
              <Button
                component={Link}
                href={"/contact"}
                variant="contained"
                size="large"
                sx={{
                  background:
                    "linear-gradient(45deg, #bb0000 30%, #ff4444 90%)",
                  color: "white",
                  "&:hover": {
                    background:
                      "linear-gradient(45deg, #990000 30%, #ff3333 90%)",
                    transform: "translateY(-2px)",
                    boxShadow: "0 5px 15px rgba(187, 0, 0, 0.3)",
                  },
                  transition: "all 0.3s ease",
                  mt: 2,
                  animation: "fadeInUp 0.8s ease-out 0.4s backwards",
                }}
              >
                Contact Us
              </Button>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box
                component="img"
                src="https://res.cloudinary.com/duaz5kg1m/image/upload/v1739271189/dgau8mp7vukxlrsmymcn.jpg"
                alt="Vastu harmony illustration"
                sx={{
                  width: "100%",
                  maxWidth: 600,
                  height: "auto",
                  borderRadius: 4,
                  boxShadow: "0 20px 40px rgba(187, 0, 0, 0.15)",
                  transform: "perspective(1000px) rotateY(-5deg)",
                  transition: "all 0.5s ease",
                  "&:hover": {
                    transform:
                      "perspective(1000px) rotateY(0deg) translateY(-10px)",
                    boxShadow: "0 25px 50px rgba(187, 0, 0, 0.2)",
                  },
                  animation: "fadeInRight 1s ease-out",
                  "@keyframes fadeInRight": {
                    from: {
                      opacity: 0,
                      transform:
                        "perspective(1000px) rotateY(-5deg) translateX(50px)",
                    },
                    to: {
                      opacity: 1,
                      transform:
                        "perspective(1000px) rotateY(-5deg) translateX(0)",
                    },
                  },
                }}
              />
            </Grid>
          </Grid>
        </Container>
      </Box>
      {/* How It Works Section */}
      <Box sx={{ py: 8, background: "rgba(187, 0, 0, 0.02)" }}>
        <Container>
          <Typography
            variant="h3"
            component="h2"
            textAlign="center"
            gutterBottom
            sx={{
              color: "#bb0000",
              mb: 6,
              position: "relative",
              "&::after": {
                content: '""',
                position: "absolute",
                bottom: -16,
                left: "50%",
                transform: "translateX(-50%)",
                width: 80,
                height: 3,
                background:
                  "linear-gradient(90deg, transparent, #bb0000, transparent)",
                borderRadius: 2,
              },
            }}
          >
            How It Works
          </Typography>
          <Grid container spacing={4} sx={{ mt: 4 }}>
            {[
              "Create your property profile",
              "Outline your boundaries on Google Maps",
              "Upload your floor plan",
              "Synchronize your floor plan with google maps",
              "Drag and Drop your house entities",
              "Voilà! Get instant Vastu report",
              "Transform your space",
            ].map((step, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Box
                  sx={{
                    textAlign: "center",
                    p: 3,
                    background: "white",
                    borderRadius: 3,
                    border: "1px solid rgba(187, 0, 0, 0.1)",
                    boxShadow: "0 4px 20px rgba(187, 0, 0, 0.05)",
                    transition: "all 0.3s ease-in-out",
                    animation: `fadeInUp 0.8s ease-out ${
                      index * 0.1
                    }s backwards`,
                    "&:hover": {
                      transform: "translateY(-4px)",
                      boxShadow: "0 8px 30px rgba(187, 0, 0, 0.1)",
                      "& .step-number": {
                        color: "#bb0000",
                        transform: "scale(1.1)",
                      },
                    },
                  }}
                >
                  <Typography
                    className="step-number"
                    variant="h1"
                    sx={{
                      fontSize: "3.5rem",
                      color: "rgba(187, 0, 0, 0.6)",
                      fontWeight: 800,
                      mb: 2,
                      transition: "all 0.3s ease-in-out",
                    }}
                  >
                    {index + 1}
                  </Typography>
                  <Typography
                    variant="h6"
                    component="h3"
                    sx={{
                      color: "#333",
                      fontWeight: 600,
                      lineHeight: 1.5,
                      fontSize: "1rem",
                    }}
                  >
                    {step}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Services Section */}
      <Container sx={{ py: 8 }}>
        <Typography
          variant="h3"
          component="h2"
          textAlign="center"
          gutterBottom
          sx={{
            background: "linear-gradient(45deg, #bb0000 30%, #ff4444 90%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            fontWeight: 600,
            mb: 6,
            position: "relative",
            "&::after": {
              content: '""',
              position: "absolute",
              bottom: -16,
              left: "50%",
              transform: "translateX(-50%)",
              width: 80,
              height: 3,
              background:
                "linear-gradient(90deg, transparent, #bb0000, transparent)",
              borderRadius: 2,
            },
          }}
        >
          Our Services
        </Typography>
        <Grid container spacing={4} sx={{ mt: 4 }}>
          {[
            {
              title: "Vastu Analysis",
              description: "Get instant Vastu analysis for your floor plan",
            },
            {
              title: "Expert Consultation",
              description: "Connect with certified Vastu experts",
            },
            {
              title: "Vastu Mapping",
              description:
                "Receiving comprehensive Vastu recommendations has never been so easier",
            },
          ].map((feature, index) => (
            <Grid item xs={12} md={4} key={feature.title}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  background: "rgba(255, 255, 255, 0.9)",
                  color: "#333",
                  borderRadius: 3,
                  border: "1px solid rgba(187, 0, 0, 0.1)",
                  boxShadow: "0 8px 32px rgba(187, 0, 0, 0.05)",
                  backdropFilter: "blur(10px)",
                  position: "relative",
                  overflow: "hidden",
                  transition: "all 0.3s ease-in-out",
                  animation: `fadeInUp 0.8s ease-out ${index * 0.2}s backwards`,
                  "&:hover": {
                    transform: "translateY(-8px)",
                    boxShadow: "0 12px 40px rgba(187, 0, 0, 0.15)",
                    "& .card-gradient": {
                      opacity: 1,
                    },
                  },
                }}
              >
                <div
                  className="card-gradient"
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: "4px",
                    background: "linear-gradient(90deg, #ff4444, #bb0000)",
                    opacity: 0,
                    transition: "opacity 0.3s ease-in-out",
                  }}
                />
                <CardContent sx={{ p: 4 }}>
                  <Typography
                    variant="h5"
                    component="h3"
                    gutterBottom
                    sx={{
                      background:
                        "linear-gradient(45deg, #bb0000 30%, #ff4444 90%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      fontWeight: 600,
                      mb: 2,
                    }}
                  >
                    {feature.title}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#555",
                      lineHeight: 1.6,
                    }}
                  >
                    {feature.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
      {/* Newsletter Section */}
      <Container sx={{ py: 8 }}>
        <ToastContainer autoClose={2000} />
        <Box
          sx={{
            background: "white",
            borderRadius: 3,
            p: { xs: 3, md: 5 },
            textAlign: "center",
            boxShadow: "0 4px 30px rgba(187, 0, 0, 0.1)",
            border: "1px solid rgba(187, 0, 0, 0.1)",
            position: "relative",
            overflow: "hidden",
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              height: "4px",
              background: "linear-gradient(90deg, #ff4444, #bb0000)",
            },
          }}
        >
          <Typography
            variant="h4"
            component="h2"
            gutterBottom
            sx={{
              color: "#bb0000",
              fontWeight: 600,
              mb: 2,
            }}
          >
            Stay Updated with Vastu Tips
          </Typography>
          <Typography
            variant="body1"
            paragraph
            sx={{
              color: "#666",
              mb: 4,
              maxWidth: "800px",
              mx: "auto",
            }}
          >
            Subscribe to our newsletter for the latest Vastu insights and
            updates
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubscribe}
            sx={{
              display: "flex",
              gap: 2,
              maxWidth: 600,
              mx: "auto",
              flexDirection: { xs: "column", sm: "row" },
            }}
          >
            <TextField
              variant="outlined"
              placeholder="Enter your email"
              fullWidth
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              sx={{
                "& .MuiOutlinedInput-root": {
                  bgcolor: "#fff",
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(187, 0, 0, 0.3)",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#bb0000",
                  },
                },
              }}
            />
            <Button
              type="submit"
              variant="contained"
              size="large"
              sx={{
                bgcolor: "#bb0000",
                color: "white",
                px: 4,
                "&:hover": {
                  bgcolor: "#990000",
                  transform: "translateY(-2px)",
                  boxShadow: "0 5px 15px rgba(187, 0, 0, 0.3)",
                },
                transition: "all 0.3s ease",
                fontWeight: 600,
                textTransform: "none",
              }}
            >
              Subscribe
            </Button>
          </Box>
        </Box>
      </Container>
      <Footer />
    </Box>
  );
};

export default VastuLandingPage;
